import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {StockMovementAuditReportModel} from "../stock-movement-audit-report.model";
import {Component} from "@angular/core";
import {EntityGroupByReportCriteriaComponent} from "../../../../reports/common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";

@Component({
    selector: "wbo-stock-movement-audit-option-report",
    templateUrl: "./stock-movement-audit-option-report.component.html"
})
export class StockMovementAuditOptionReportComponent {
    constructor(public model: StockMovementAuditReportModel, public editService: EditService) {
    }

    get showOutletOption(): boolean {
        return this.model.data.reportType !== EntityGroupByReportCriteriaComponent.INVENTORY_VALUE;
    }

}
